import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import ProductDefinitionEditor from "./ProductDefinitionEditor";

export const fetchProduct = async (code) => {
  const response = await fetch(`https://poc.mrc.ai/${code}/api/product`);
  if (!response.ok) {
    throw new Error(`Failed to fetch product for code: ${code}`);
  }
  const json = await response.json();
  console.log("Fetched product data:", json);
  return Array.isArray(json) ? json[0] : json; // ✅ unwrap the array
};

const ProductDefinitionEditorPage = () => {
  const { productCode } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [product, setProduct] = useState(null);
  const [isNew, setIsNew] = useState(state?.isNew || false);

  useEffect(() => {
    if (!isNew) {
      fetchProduct(productCode).then(setProduct);
    } else {
      setProduct({
        _id: null,
        code: productCode,
        name: "",
        clockId: "",
        dataStandardVersionCode: "",
        description: "",
        routing: {
          signalsEndpoint: "",
          triggersEndpoint: "",
          eventsEndpoint: "",
          productEndpoint: "",
        },
        signalRegister: [],
        triggerRegister: [],
        eventRegister: [],
        roleDefinitions: [],
        activityPatternDefinitions: [],
        tiptapDocumentTemplate: "",
        createdDate: new Date().toISOString(),
        productTemplates: [],
      });
    }
  }, [productCode, isNew]);

  if (!product) return <Spinner />;

  const handleClose = () => {
    // Change this to window.history.back()
    window.history.back();
  };

  return (
    <ProductDefinitionEditor
      product={product}
      isNew={isNew}
      onSave={(updatedProduct, wasNew) => {
        setProduct(updatedProduct);
        if (wasNew) {
          setIsNew(false);
          navigate(`/poc/product/${updatedProduct.code}/edit`, {
            state: { isNew: false },
          });
        }
      }}
      onBack={handleClose}
    />
  );
};

export default ProductDefinitionEditorPage;
